import { Component, ViewChild, ElementRef,  OnInit, HostListener, ContentChildren} from '@angular/core';
import { CarouselItemDirective } from './carousel-item.directive';
@Component({
  selector: 'lib-carousel-item',
  template: `
  <div class="slider-container">
  <div class="slides" #slides>
    <ng-content select="[libCarouselItem]" #sliderItem></ng-content>
  </div>
  <div class="controls">
    <a class="prev btn" [hidden]="slidesIndex === 0" (click)="onClickLeft()">&#10094;</a>
    <a class="next btn" [hidden]="slidesIndex * mobileSlider >= items.length - 1" (click)="onClickRight()">&#10095;</a>
  </div>
</div>
  `,
  styles: [`
  .slider-container {
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .slides {
    display: flex;
    overflow: hidden;
    scroll-behavior: smooth;
  }
  .controls {
    display: flex;
    justify-content: center;
  }
  .next {
    right: 0;
  }
  .prev {
    left: 0;
  }
  .prev, .next {
    cursor: pointer;
    position: absolute;
    top: 40%;
    width: auto;
    margin-top: -22px;
    box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);
    font-weight: bold;
    font-size: 12px;
    transition: 1s ease;
    border-radius: 0 3px 3px 0;
    user-select: contain;
    display: block;
    border-radius: 10%;
    z-index: 100;
  }
  @media only screen and (max-width: 900px) {
    .prev , .next  {
      background-color: rgba(255, 255, 255, 0);
      color: #050102;
    }
  }
  @media only screen and (min-width: 900px) {
    .prev, .next  {
      background-color: rgba(255, 255, 255, 0.021);
      color: #0e0005;
    }
  }`]
})
export class CarouselItemComponent implements OnInit {
    @ContentChildren(CarouselItemDirective, { read: ElementRef }) items;
    @ViewChild('slides', {static: true}) slidesContainer: ElementRef<HTMLDivElement>;
    slidesIndex = 0;
    mobileSlider = 1;
    ngOnInit() {
    }
    get currentItem(): ElementRef<HTMLDivElement> {
      return this.items.find((item, index) => index === this.slidesIndex);
    }
    onClickLeft() {
      this.slidesContainer.nativeElement.scrollLeft -= this.currentItem.nativeElement.offsetWidth * this.mobileSlider;
      if (this.slidesIndex * this.mobileSlider > 0) {
        this.slidesIndex--;
      }
    }
    onClickRight() {
      this.slidesContainer.nativeElement.scrollLeft += this.currentItem.nativeElement.offsetWidth * this.mobileSlider;
      if (this.slidesIndex * this.mobileSlider < this.items.length - 1) {
        this.slidesIndex++;
      }
    }
  defaultTouch = { x: 0, y: 0, time: 0 };
  @HostListener('touchstart', ['$event'])
  @HostListener('touchend', ['$event'])
  @HostListener('touchcancel', ['$event'])
  handleTouch(event) {
      let touch = event.touches[0] || event.changedTouches[0];
      // check the events
      if (event.type === 'touchstart') {
          this.defaultTouch.x = touch.pageX;
          this.defaultTouch.y = touch.pageY;
          this.defaultTouch.time = event.timeStamp;
      } else if (event.type === 'touchend') {
          let deltaX = touch.pageX - this.defaultTouch.x;
          let deltaY = touch.pageY - this.defaultTouch.y;
          let deltaTime = event.timeStamp - this.defaultTouch.time;
          // simulte a swipe -> less than 500 ms and more than 60 px
          if (deltaTime < 500) {
              // touch movement lasted less than 500 ms
              if (Math.abs(deltaX) > 60) {
                  // delta x is at least 60 pixels
                  if (deltaX > 0) {
                      this.doSwipeRight(event);
                  } else {
                      this.doSwipeLeft(event);
                  }
              }
          }
      }
  }
  doSwipeLeft(event) {
      this.onClickRight();
  }
  doSwipeRight(event) {
      this.onClickLeft();
  }
  }
  